module.exports = {
  'bgColor': '#73a582',
  'fgColor': '#000000'
};
